<template>
    <div class="step phone">
        <AdvSubTitle>{{ $t("common:signLog.adv.phoneSubtitle") }} </AdvSubTitle>
        <AdvTitle
            class="mt-8"
            :class="[isMobileSize ? 'mb-20' : 'mb-32']"
        >
            {{ $t("common:signLog.adv.phoneTitle") }}
        </AdvTitle>
        <AdvInput
            ref="input"
            v-bind="inputConfig"
            @changeValue="changeValue"
        />
        <AdvBtn
            class="mb-30"
            :class="[isMobileSize ? 'mt-10' : 'mt-24', disclaimerSubmitDisabled ? 'disabled' : '']"
            :title="disclaimerSubmitDisabled ? $t('common:customDisclaimerTip'):''"
            @click="handleNext"
        >
            {{ $t("common:signLog.adv.phoneBtn") }}
        </AdvBtn>
        <disclaimer
            :disclaimerUniqId="disclaimerUniqId"
            @updateChecked="updateChecked"
            class="pop-register-disclaimer"
            color="#505050"
            :privacyText="disclaimerPrivacyText"
            :btnText="$t('common:signLog.adv.phoneBtn')"
        />
        <AdvDescript
            class="bt pb-30"
        >
            {{ $t("common:signLog.adv.phoneDesc") }}
        </AdvDescript>
        <AdvProgress
            class="pt-34 mb-32 btop"
            :value="progress()"
            v-if="!isMobileSize"
        />
    </div>
</template>
<script>
import axios from 'axios';
import register from '../../register.js';
import AdvBtn from './components/btn.vue';
import AdvDescript from './components/descript.vue';
import AdvInput from './components/input.vue';
import AdvProgress from './components/progress.vue';
import AdvSubTitle from './components/subTitle.vue';
import AdvTitle from './components/title.vue';
import common from './common';
import { phoneLoginFormat, phone_regex } from "@/common/format/phone-format.js";
export default {
    mixins: [register, common],
    data: function() {
        return {
            inputConfig: {
                placeholder: `Phone (also used as your password)`,
                validator: this.validatePhone,
                errorMsg: 'Please enter a valid phone number',
                maxLength: 12,
                formatter: phoneLoginFormat,
            },
            value: '',
            noShowCustomDisclaimer: true
        };
    },
    inject: ['progress', 'next', 'locations'],
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
    },
    methods: {
        changeValue(v) {
            this.value = v;
        },
        //  rewrite mixin of  registerNext  no bomb questionnaire 
        registerNext() {
            this.onRegisterCallback(this.options.onregister, false);
            this.destroy();
            this.onSuccessCallback(this.options.onsuccess);
        },
        async handleNext() {
            let pass = await this.$refs.input._validate();
            if (pass) {
                this.next(
                    {
                        phone: this.value
                    },
                    null,
                    submitParams => {
                        const params = {
                            ...submitParams,
                            locations: this.locations
                        };
                        this.registerSubmit(this.$el, params);
                        this.registerSubmitSuccess(params);
                    }
                );
            }
        },

        async validatePhone(val) {
            val = val.trim();
            if (val.length) {
                const reg = phone_regex.normal;
                const error = { errorInfo: 'Phone invalid' };
                if (!reg.test(val)) {
                    return Promise.reject(error); 
                }
                return new Promise((resolve, reject) => {
                    axios
                        .get(`/api-site/phoneValidate?phoneNumber=${val}`)
                        .then(res => {
                            resolve(res?.status?.code == 0);
                        })
                        .catch(e => reject(e));
                });
            } else {
                return Promise.reject({
                    errorInfo: this.$t('common:validate.fieldRequired')
                });
            }
        }
    },
    components: {
        AdvBtn,
        AdvDescript,
        AdvInput,
        AdvProgress,
        AdvSubTitle,
        AdvTitle
    }
};
</script>
<style lang="scss" scoped>
.advertisting-register-pop .step .mt-24{
    margin-bottom: 0;
}
.disclaimer-wrap.opt-in.pop-register-disclaimer{
    margin-top:20px;
}
.disabled{
    position: relative;
    &:after{
        content: '';
        position: absolute;
        cursor: not-allowed;
        left: 0;
        right:0;
        top:0;
        bottom: 0;
        background-color: rgba(255,255,255,.5);
    }
}
.advertisting-register-pop .step .bt{
    margin-top: 20px;
}
</style>
